import { useEffect, useRef, useState } from "react";
import lr from "./assets/LR.png";
import riarr from "./assets/RR.png";
import "./Automated.css";

const AutomatedRecommend = () => {
    const [index, setIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    const prevIndexRef = useRef(0);

    const items = [
        {
            id: "optimize-resource",
            title: "Optimizes Resource Utilization",
            description:
                "Systematically allocates your workforce according to real workload requirements, preventing understaffing and overstaffing while ensuring optimal resource utilization and balanced operational efficiency.",
        },
        {
            id: "compliance-safety",
            title: "Compliance and Enhances Safety",
            description:
                "Ensures safety protocols and regulatory standards are consistently followed in every assignment, minimizing organizational risk and promoting a secure, compliant, and reliable work environment.",
        },
        {
            id: "data-decisions",
            title: "Data for Strategic Decisions",
            description:
                "Enables comprehensive performance analysis, detailed cost reporting, and precise capacity planning using accurate real-time data to support informed decisions and drive operational excellence.",
        },
        {
            id: "agility",
            title: "Improves Agility and Responsiveness",
            description:
                "Enables businesses to swiftly adapt to shifting priorities, unexpected absences, or urgent work orders by instantly re-running the automated allocation process for optimal efficiency.",
        },
    ];

    const goPrev = () => {
        setIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
    };

    const goNext = () => {
        setIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
    };

    const togglePause = () => setIsPaused((p) => !p);


    useEffect(() => {
        prevIndexRef.current = index;
    }, [index]);


    useEffect(() => {
        if (isPaused) return;

        const timer = setInterval(goNext, 4000);
        return () => clearInterval(timer);
    }, [isPaused]);

    return (
        <div className="w-full bg-[#f9f9f9] py-12 px-6 md:px-10 lg:px-14 xl:px-20">
            <div className="max-w-[1300px] mx-auto flex flex-wrap items-center justify-center gap-6 relative">

                <div className="w-full md:flex-1 font-epilogue font-bold text-[#1c1c1c]
          text-[26px] sm:text-[30px] md:text-[32px] lg:text-[36px]
          text-center md:text-left leading-tight">
                    Why We Recommend <br /> Automation Work
                </div>


                <div onClick={goPrev} className="cursor-pointer hidden sm:block">
                    <img src={lr} alt="Previous" className="w-10 h-10" />
                </div>


                <div className="w-full md:flex-1 bg-white rounded-3xl shadow-lg
          p-8 max-w-[700px] min-h-[260px]
          flex flex-col justify-center text-center md:text-left">
                    <h3 className="text-[#1c1c1c] font-bold text-[24px] mb-4">
                        {items[index].title}
                    </h3>
                    <p className="text-[#7d8c9e] text-[15px] leading-relaxed">
                        {items[index].description}
                    </p>
                </div>

                <div onClick={goNext} className="cursor-pointer hidden sm:block">
                    <img src={riarr} alt="Next" className="w-10 h-10" />
                </div>

                <div className="absolute bottom-[10px] left-[66%] -translate-x-1/2 flex items-center gap-4">
                    <div
                        onClick={togglePause}
                        className="w-8 h-8 bg-[#1E72BB] rounded-full
    text-white flex items-center justify-center cursor-pointer"
                    >
                        {isPaused ? "▶" : "⏸"}
                    </div>

                    <div className="flex gap-3">
                        {items.map((item, i) => (
                            <div
                                key={item.id}
                                onClick={() => setIndex(i)}
                                className={`bg-recom ${index === i ? "bg-recom-active" : ""}`}
                            />
                        ))}
                    </div>

                </div>

            </div>
        </div>
    );
};

export default AutomatedRecommend;
